import client from '../base-api';

const serviceURL = '/province';

const regionService = {

    // Region
    getRegions() {
        return client.get(`${serviceURL}`);
    },
    getRegion(regionId: number) {
        return client.get(`${serviceURL}/${regionId}`);
    },
    postRegion(regionData: any) {
        return client.post(`${serviceURL}`, regionData);
    },
    putRegion(regionData: any, regionId: number) {
        return client.put(`${serviceURL}/${regionId}`, regionData);
    },
    deleteRegion(regionId: number) {
        return client.delete(`${serviceURL}/delete/${regionId}`);
    },

    // Region holidays
    getRegionHolidays(regionId: number, filterData: any) {
        return client.get(`${serviceURL}/holidays/${regionId}`, {params: filterData});
    },
    postRegionHoliday(holidayData: any) {
        return client.post(`${serviceURL}/holidays`, holidayData);
    },
    putRegionHoliday(holidayData: any, holidayId: number) {
        return client.put(`${serviceURL}/holidays/${holidayId}`, holidayData);
    },
    deleteRegionHoliday(holidayId: number) {
        return client.delete(`${serviceURL}/holidays/${holidayId}`);
    }
}

export default regionService;